import { IconButton, List, ListItem, ListItemButton, ListItemText, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { TellerPostingApprovalTablePropsType } from "../../../types/container.type";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { formatDate } from "../../../helpers/dateFormatter";

export const TellerPostingApprovalTable: React.FC<TellerPostingApprovalTablePropsType> = ({ rows, handleActionButtonClick, selectedTransactionId, dropdownRef, handleActionItemClick }) => {
    const actions = ["Approve", "Decline"];
    const tellerPostingApprovalTableHeaders = ["Account Name", "Transaction Type", "Amount", "Date", "Action"];

    return (
        <BaseTable
            headers={tellerPostingApprovalTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        <TableCell>{row?.accountName?.split(" ").map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}</TableCell>
                        <TableCell>
                            {row?.type
                                ?.replace(/-/g, " ")
                                ?.replace(/\b\w/g, (char: string) => char.toUpperCase())}
                        </TableCell>
                        <TableCell>
                            {(() => {
                                const value = row?.amount ?? 0;
                                const parts = value.toString().split(".");
                                if (parts.length === 1) return value.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                                const decimalPlaces = parts[1].length;
                                return value.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: decimalPlaces
                                });
                            })()}
                        </TableCell>
                        <TableCell>{formatDate(row?.createdAt, true)}</TableCell>
                        <TableCell>
                            <IconButton
                                sx={{
                                    borderRadius: "0.5rem",
                                    backgroundColor: "var(--sky-blue-color)",
                                    "&:hover": {
                                        backgroundColor: "var(--sky-blue-color)"
                                    }
                                }}
                                onClick={(e) => handleActionButtonClick(e, { id: row?.id, institution: row?.institution, referenceType: row?.referenceType, reference: row?.bankAccountReference ?? row?.glReference, transactionType: row?.type, amount: row?.amount })}
                            >
                                <MoreVertIcon
                                    sx={{
                                        color: "#FFFFFF",
                                        display: "inline-flex",
                                    }}
                                />
                            </IconButton>
                            {(selectedTransactionId && selectedTransactionId === row?.id) && (
                                <List
                                    component={"ul"}
                                    ref={dropdownRef}
                                    className="dropdown-modal"
                                >
                                    {actions.map((action, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={(e) => handleActionItemClick(e, selectedTransactionId, action)}
                                        >
                                            <ListItemButton>
                                                <ListItemText
                                                    primary={action}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </BaseTable >
    )
}